import {
  TableOperatorNames,
  TableOperatorType,
} from 'ui/components/DataTable/types';

export const defaultChildOrgMembersFilterValue = [
  {
    name: 'member',
    operator: TableOperatorNames.StartsWith,
    type: TableOperatorType.String,
    value: '',
  },
  {
    name: 'type',
    operator: TableOperatorNames.Equals,
    type: TableOperatorType.String,
    value: '',
  },
  {
    name: 'organization',
    operator: TableOperatorNames.StartsWith,
    type: TableOperatorType.String,
    value: '',
  },
  {
    name: 'ecosystem',
    operator: TableOperatorNames.Equals,
    type: TableOperatorType.String,
    value: '',
  },
];
